type UserLike = {
  name?: string | null;
  email?: string | null;
};

/**
 * Display label for a user. `name` is nullable in the API (e.g. users invited
 * by email who have not accepted yet), so fall back to the email.
 */
export function userLabel(user: UserLike | null | undefined): string {
  const name = user?.name?.trim();
  if (name) {
    return name;
  }
  return user?.email?.trim() || '';
}
